import CreationDetailTable from "./CreationDetailTable";
import DraftLegDetail from "./DraftLegDetail";
import { isDraftLegRow } from "./helper/cellRenderers/DraftLeg/useDraftLegTicket";

// LQC-2941 - one detail renderer for the Trade Creation grid: a real block shows its
// allocations table, a draft leg shows its allocation picker and Security Details.
const CreationDetailRenderer = (props: any) => {
  if (isDraftLegRow(props.data)) return <DraftLegDetail data={props.data} />;
  return <CreationDetailTable {...props} />;
};

export default CreationDetailRenderer;
